exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/my-payment/my-payment.component.css
// module id = ../../../../../src/app/my-payment/my-payment.component.css
// module chunks = main